import React, { FC, ChangeEvent } from 'react'
import { RadioProps, Box, Text, ControlBox } from '@chakra-ui/core'
import { Hidden } from '../Hidden'

export interface Props extends RadioProps {
  title: string
  subTitle?: string
  checked?: boolean
  value: string
  name: string
  onChangeEvent: (event: ChangeEvent<HTMLInputElement>) => void
}

export const DetailRowWithRadioButton: FC<Props> = ({
  title,
  subTitle,
  value,
  name,
  onChangeEvent,
  checked = false,
}) => {
  return (
    <label>
      <Box
        d="flex"
        flexDir="row"
        justifyContent="space-between"
        backgroundColor="white"
        borderTop="1px solid"
        borderColor="gray.500"
        py="2"
        px="6"
        minH="48px"
        h="48px"
        w="100%"
      >
        <Box verticalAlign="top" flex="4" d="flex" flexDir="column" alignSelf="center">
          <Text m="0" textAlign="left" fontWeight="bold" fontSize="12px">
            {title}
          </Text>
          {subTitle && (
            <Text m="0" textAlign="left" fontSize="11px">
              {subTitle}
            </Text>
          )}
        </Box>

        <Hidden
          type="radio"
          as="input"
          name={name}
          checked={checked}
          value={value}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            onChangeEvent(event)
          }}
        />

        {/* This is the control box with a circle as children */}
        <ControlBox
          d="flex"
          alignSelf="center"
          size="16px"
          bg="white"
          border="2px solid"
          rounded="full"
          type="radio"
          marginRight="1"
          borderColor="gray.50"
          _focus={{ boxShadow: 'outline' }}
          _hover={{ borderColor: 'primary.500' }}
          _disabled={{ borderColor: 'gray.200' }}
          _checked={{ bg: 'primary.500', borderColor: 'primary.500' }}
        >
          <Box size="50%" bg="white" rounded="full" />
        </ControlBox>
      </Box>
    </label>
  )
}
